import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import { EmailRequiredInfo } from "../../../../../components/guardian/ManualEntryFields";
import {
  getPrincipalEmailVisibility,
  principalEmailShowsNoteBanner,
  principalEmailBannerEsignFlag,
} from "../../principalFormUtils";

export default function PrincipalEmailSection({
  cfg,
  index,
  guardian,
  guardians,
  globalData,
  keys,
  gVal,
  data,
  updateData,
}) {
  if (!getPrincipalEmailVisibility(cfg, guardian, globalData)) return null;

  const withBanner = principalEmailShowsNoteBanner(cfg);

  const onEmailChange = (emailValue) => {
    const updatedGuardians = [...guardians];
    updatedGuardians[index] = {
      ...updatedGuardians[index],
      [keys.email]: emailValue,
    };
    updateData({ ...data, guardians: updatedGuardians });
  };

  return (
    <>
      {withBanner ? (
        <EmailRequiredInfo
          isNewPg={guardian.is_new_pg}
          isEsignatures={principalEmailBannerEsignFlag(cfg, guardian, globalData)}
        />
      ) : null}
      <TextField
        sx={{ mb: 2 }}
        label="Email"
        value={gVal(guardian, keys, "email")}
        onChange={(e) => onEmailChange(e.target.value)}
        fullWidth
        required
      />
    </>
  );
}

PrincipalEmailSection.propTypes = {
  cfg: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.arrayOf(PropTypes.object).isRequired,
  globalData: PropTypes.object,
  keys: PropTypes.object.isRequired,
  gVal: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
};
